// extracted by mini-css-extract-plugin
export default {"screen":"classes_screen__+CYa-","img":"classes_img__6qShD","title":"classes_title__-H3Zd"};